import { Component, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'lin-uninstall-dialog',
  templateUrl: './uninstall-dialog.component.html',
  styleUrls: ['./uninstall-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UninstallDialogComponent {}
